function targetForFix({ lat, lon, zoom, pitch, bearing }) {
  const target = { center: [lon, lat] }
  if (zoom != null) target.zoom = zoom
  if (pitch != null) target.pitch = pitch
  if (bearing != null) target.bearing = bearing
  return target
}

function followLike(mode) {
  return mode === "following" || mode === "paused"
}

export function browserFollowCameraPlan({
  mode,
  tracking,
  centerRequested = false,
  zoomedToLive,
  lat,
  lon,
  followZoom,
  followPitch,
  bearing
}) {
  if (!tracking && !followLike(mode)) return { accepted: false }

  const plan = { accepted: true }
  if (mode !== "following") return plan

  // During a trip the tracker normally owns camera movement. If Live was tapped
  // before its first point arrives, accept the explicit one-shot browser fix.
  if (tracking && !centerRequested) return plan

  const firstLiveMove = centerRequested || !zoomedToLive
  plan.forceNextAutoSearch = firstLiveMove
  plan.zoomedToLive = firstLiveMove ? true : zoomedToLive
  plan.move = {
    target: targetForFix({
      lat,
      lon,
      zoom: firstLiveMove ? followZoom : null,
      pitch: firstLiveMove ? followPitch : null,
      bearing
    }),
    options: { duration: firstLiveMove ? 500 : 400 }
  }
  return plan
}

export function trackingFollowCameraPlan({
  mode,
  zoomedToFollow,
  lat,
  lon,
  followZoom,
  followPitch,
  bearing
}) {
  if (mode !== "following") return { move: null, zoomedToFollow }

  const firstFollowMove = !zoomedToFollow
  return {
    zoomedToFollow: firstFollowMove ? true : zoomedToFollow,
    move: {
      target: targetForFix({
        lat,
        lon,
        zoom: firstFollowMove ? followZoom : null,
        pitch: firstFollowMove ? followPitch : null,
        bearing
      }),
      options: { duration: firstFollowMove ? 500 : 400 }
    }
  }
}
